(function () {
  'use strict';

  function init() {
    var drawer = document.getElementById('mk-samples-drawer');
    if (!drawer) return;

    // Reparent til body for at undgå main-product stacking context (drawer havner ellers bag header-menuen).
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    var grid = drawer.querySelector('[data-samples-grid]');
    var fabricNameEl = drawer.querySelector('[data-samples-fabric-name]');
    var emptyEl = drawer.querySelector('[data-samples-empty]');
    var infoEl = drawer.querySelector('.mk-samples-drawer__info');
    var footerEl = drawer.querySelector('.mk-samples-drawer__footer');
    var cta = drawer.querySelector('[data-samples-add-to-cart]');
    var ctaLabel = drawer.querySelector('[data-samples-cta-label]');
    var countEl = drawer.querySelector('[data-samples-count]');
    var MAX = parseInt(drawer.dataset.maxSamples, 10) || 5;
    var EMPTY_MSG = drawer.dataset.emptyMsg || 'Ingen stofprøver tilgængelige';
    var LOADING_MSG = drawer.dataset.loadingMsg || 'Henter stofprøver…';
    var MONEY_FORMAT = drawer.dataset.moneyFormat || '{{amount}} kr';
    var CURRENT_HANDLE = drawer.dataset.currentProductHandle || '';
    var PRODUCT_FWS = (drawer.dataset.productFws || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var PRODUCT_VARIANT_COLORS = {};
    (drawer.dataset.productVariantColors || '').split(';;').forEach(function (pair) {
      if (!pair) return;
      var idx = pair.indexOf('::');
      if (idx < 0) return;
      var fw = pair.slice(0, idx).trim().toLowerCase();
      var color = pair.slice(idx + 2).trim();
      if (!fw || !color) return;
      (PRODUCT_VARIANT_COLORS[fw] = PRODUCT_VARIANT_COLORS[fw] || []).push(color);
    });

    var data = {};
    var loadingPromise = null;

    function formatPrice(cents) {
      // Stofprøver er små beløb (typisk 0 kr) — vi viser altid uden decimaler.
      var formatted = Math.round(cents / 100).toLocaleString('da-DK');
      return MONEY_FORMAT.replace(/\{\{[^}]+\}\}/g, formatted);
    }

    function getCacheKey(fw) {
      // v2: priceFormatted droppet fra cache så pris-format-ændringer slår
      // straks igennem uden at gammel session blokerer.
      return 'mk-samples-cache-v2-' + fw;
    }

    function loadFromSessionCache(fw) {
      try {
        var raw = sessionStorage.getItem(getCacheKey(fw));
        return raw ? JSON.parse(raw) : null;
      } catch (e) { return null; }
    }

    function saveToSessionCache(fw, entry) {
      try { sessionStorage.setItem(getCacheKey(fw), JSON.stringify(entry)); } catch (e) {}
    }

    var DEBUG = (window.location.search.indexOf('mksdebug') !== -1) || window.MK_SAMPLES_DEBUG === true;
    function log() {
      if (!DEBUG) return;
      var args = ['[mk-samples]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }

    function fetchSampleProduct(firstWord) {
      var fw = (firstWord || '').toLowerCase();
      if (!fw) {
        log('fetchSampleProduct: no firstWord given');
        return Promise.resolve(null);
      }
      log('fetchSampleProduct: searching for first-word', fw);

      var cached = loadFromSessionCache(fw);
      if (cached) {
        log('fetchSampleProduct:', fw, '→ loaded from sessionStorage cache', cached);
        return Promise.resolve(cached);
      }

      // Append locale stofprøve-keyword + limit=20: biaser Shopify-relevance mod stofprøve-produkter,
      // ellers fylder family-navne som "Loop" top 10 med sofaer og selve "Loop - Stofprøve" ryger ud.
      var localeKeyword = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0 ? 'stoffprobe' : 'stofprøve';
      var searchUrl = '/search/suggest.json?q=' + encodeURIComponent(fw + ' ' + localeKeyword)
        + '&resources[type]=product&resources[limit]=20';
      log('fetchSampleProduct:', fw, '→ predictive search url:', searchUrl);
      return fetch(searchUrl, { credentials: 'same-origin' })
        .then(function (r) {
          log('fetchSampleProduct:', fw, '→ search response status:', r.status);
          return r.ok ? r.json() : null;
        })
        .then(function (json) {
          if (!json) {
            log('fetchSampleProduct:', fw, '→ no JSON returned');
            return null;
          }
          var products = (json.resources && json.resources.results && json.resources.results.products) || [];
          log('fetchSampleProduct:', fw, '→ got', products.length, 'products:', products.map(function (p) {
            return { title: p.title, type: p.type, handle: p.handle };
          }));
          var match = products.find(function (p) {
            var titleFw = (p.title || '').split(' ')[0].toLowerCase();
            var type = (p.type || '').toLowerCase();
            var matches = titleFw === fw && (type === 'stofprove' || type === 'stoffprobe' || (p.handle || '').toLowerCase().indexOf('stofprove') !== -1 || (p.handle || '').toLowerCase().indexOf('stoffprobe') !== -1);
            log('  → checking', p.title, '| titleFw="' + titleFw + '" vs "' + fw + '" | type="' + type + '" | matches=' + matches);
            return matches;
          });
          if (!match || !match.handle) {
            log('fetchSampleProduct:', fw, '→ NO MATCH found in search results');
            return null;
          }
          log('fetchSampleProduct:', fw, '→ matched:', match.title, '(handle:', match.handle + ')');
          return fetch('/products/' + match.handle + '.js', { credentials: 'same-origin' })
            .then(function (r) {
              log('fetchSampleProduct:', fw, '→ product fetch status:', r.status);
              return r.ok ? r.json() : null;
            });
        })
        .then(function (productData) {
          if (!productData) {
            log('fetchSampleProduct:', fw, '→ product data missing');
            return null;
          }
          log('fetchSampleProduct:', fw, '→ product loaded:', productData.title, 'with', (productData.variants || []).length, 'variants');
          // Title-format: "Primo - Stofprøve, 100% Polyester"
          var commaParts = (productData.title || '').split(',');
          var beforeComma = (commaParts[0] || '').trim();
          var material = commaParts.length > 1 ? commaParts.slice(1).join(',').trim() : '';
          var dashParts = beforeComma.split(' - ');
          var familyName = (dashParts[0] || '').trim();
          var entry = {
            title: productData.title,
            name: familyName,
            material: material,
            handle: productData.handle,
            url: '/products/' + productData.handle,
            variants: (productData.variants || []).map(function (v) {
              return {
                id: v.id,
                title: v.title,
                price: v.price,
                available: v.available,
                thumbnail: (v.featured_image && v.featured_image.src) || ''
              };
            })
          };
          saveToSessionCache(fw, entry);
          return entry;
        })
        .catch(function () { return null; });
    }

    function loadAllSamples() {
      if (loadingPromise) return loadingPromise;
      log('loadAllSamples: starting fetch for first-words', PRODUCT_FWS);
      loadingPromise = Promise.all(PRODUCT_FWS.map(function (fw) {
        return fetchSampleProduct(fw).then(function (entry) {
          if (entry) data[fw] = entry;
        });
      })).then(function () {
        log('loadAllSamples: complete. Loaded families:', Object.keys(data));
        return data;
      });
      return loadingPromise;
    }

    if (DEBUG) {
      log('init: drawer mounted', {
        productFws: PRODUCT_FWS,
        currentHandle: CURRENT_HANDLE,
        maxSamples: MAX
      });
    }

    var selected = new Set();
    var currentFamily = null;

    function getCurrentFabricFamily(trigger) {
      if (trigger && trigger.dataset && trigger.dataset.fabricFamily) {
        return trigger.dataset.fabricFamily.toLowerCase();
      }

      if (trigger && trigger.hasAttribute('data-from-detail-view')) {
        var detailName = document.querySelector('.mk-drawer-detail [data-detail-name]');
        if (detailName && detailName.textContent) {
          return (detailName.textContent.trim().split(' ')[0] || '').toLowerCase();
        }
      }

      // Scope variant-lookup til trigger's egen form — ellers kan en quick-add/anden form på siden ramme først.
      var form = trigger ? trigger.closest('form') : null;
      var input = form ? form.querySelector('input[name="id"]') : null;
      if (!input) input = document.querySelector('input[type="hidden"][name="id"], input[name="id"]');
      if (!input) return null;
      var variantId = input.value;
      if (!variantId) return null;

      var products = window._themeProducts || {};

      var picker = trigger ? trigger.closest('[data-variant-picker]') : null;
      var pid = picker ? picker.dataset.productId : null;
      if (pid && products[pid] && products[pid].variants) {
        for (var k = 0; k < products[pid].variants.length; k++) {
          if (String(products[pid].variants[k].id) === String(variantId)) {
            var t = products[pid].variants[k].title || products[pid].variants[k].name || '';
            return (t.split(' ')[0] || '').toLowerCase();
          }
        }
      }

      var keys = Object.keys(products);
      for (var i = 0; i < keys.length; i++) {
        var p = products[keys[i]];
        if (p && p.variants) {
          for (var j = 0; j < p.variants.length; j++) {
            if (String(p.variants[j].id) === String(variantId)) {
              var title = p.variants[j].title || p.variants[j].name || '';
              return (title.split(' ')[0] || '').toLowerCase();
            }
          }
        }
      }
      var anySelector = document.querySelector('[data-variant-id="' + variantId + '"][data-variant-title]');
      if (anySelector) {
        return (anySelector.dataset.variantTitle.split(' ')[0] || '').toLowerCase();
      }
      return null;
    }

    function escapeHtml(str) {
      return String(str || '').replace(/[&<>"']/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
      });
    }

    function renderSwatches(variants) {
      var soldOutMsg = drawer.dataset.soldOutMsg || '';
      return variants.map(function (v) {
        var disabled = v.available ? '' : 'disabled';
        var unavailableCls = v.available ? '' : ' is-unavailable';
        var img = v.thumbnail
          ? '<img src="' + escapeHtml(v.thumbnail) + '" alt="" loading="lazy" width="200" height="200">'
          : '<span class="mk-samples-swatch__placeholder"></span>';
        var soldOutBadge = v.available ? '' : '<span class="mk-samples-swatch__badge">' + escapeHtml(soldOutMsg) + '</span>';
        var priceEl = v.available ? '<span class="mk-samples-swatch__price">' + formatPrice(v.price || 0) + '</span>' : '';
        return (
          '<label class="mk-samples-swatch' + unavailableCls + '" data-variant-id="' + v.id + '">' +
            '<input type="checkbox" class="mk-samples-swatch__input" value="' + v.id + '" ' + disabled + '>' +
            '<span class="mk-samples-swatch__media">' +
              img +
              soldOutBadge +
              '<span class="mk-samples-swatch__check" aria-hidden="true">' +
                '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2"><polyline points="2,6 5,9 10,3"/></svg>' +
              '</span>' +
            '</span>' +
            '<span class="mk-samples-swatch__footer">' +
              '<span class="mk-samples-swatch__name">' + escapeHtml(v.title) + '</span>' +
              priceEl +
            '</span>' +
          '</label>'
        );
      }).join('');
    }

    function colorTokens(str) {
      return String(str || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
    }

    function sampleMatchesProduct(sampleTitle, productColors) {
      var st = colorTokens(sampleTitle);
      if (!st.length) return false;
      return productColors.some(function (pc) {
        var pt = colorTokens(pc);
        if (!pt.length) return false;
        for (var i = 0; i < pt.length; i++) {
          if (st[i] !== pt[i]) return false;
        }
        return true;
      });
    }

    function variantsForFamily(key, fam) {
      var productColors = PRODUCT_VARIANT_COLORS[key];
      if (!productColors || !productColors.length) return fam.variants;
      var filtered = fam.variants.filter(function (v) {
        return sampleMatchesProduct(v.title, productColors);
      });
      if (!filtered.length) {
        log('variantsForFamily:', key, '→ 0 sample matches for product colors', productColors, '— showing all as fallback');
        return fam.variants;
      }
      return filtered;
    }

    function renderAllFamilies(data) {
      var keys = Object.keys(data);
      if (!keys.length) return '';
      return keys.map(function (key) {
        var fam = data[key];
        if (!fam || !fam.variants || !fam.variants.length) return '';
        var variants = variantsForFamily(key, fam);
        if (!variants.length) return '';
        var heading = escapeHtml(fam.name || fam.title || key);
        var meta = fam.material ? '<p class="mk-samples-group__meta">' + escapeHtml(fam.material) + '</p>' : '';
        return (
          '<section class="mk-samples-group" data-family="' + escapeHtml(key) + '">' +
            '<div class="mk-samples-group__header">' +
              '<p class="mk-samples-group__title">' + heading + '</p>' +
              meta +
            '</div>' +
            '<div class="mk-samples-group__grid">' + renderSwatches(variants) + '</div>' +
          '</section>'
        );
      }).join('');
    }

    function updateCta() {
      var count = selected.size;
      if (countEl) countEl.textContent = '(' + count + '/' + MAX + ')';
      if (cta) cta.disabled = count === 0;
    }

    function renderDrawerContent(family) {
      var allHtml = renderAllFamilies(data);
      if (fabricNameEl) fabricNameEl.textContent = '';
      if (!allHtml) {
        grid.innerHTML = '';
        if (emptyEl) {
          emptyEl.textContent = EMPTY_MSG;
          emptyEl.hidden = false;
        }
        if (footerEl) footerEl.style.display = 'none';
      } else {
        grid.innerHTML = allHtml;
        if (emptyEl) emptyEl.hidden = true;
        if (footerEl) footerEl.style.display = '';
      }
      updateCta();
    }

    function renderSkeleton() {
      if (!PRODUCT_FWS.length) return '';
      var SWATCH_COUNT = 6;
      var swatches = '';
      for (var i = 0; i < SWATCH_COUNT; i++) {
        swatches += '<div class="mk-samples-skeleton-swatch"></div>';
      }
      return PRODUCT_FWS.map(function () {
        return (
          '<section class="mk-samples-skeleton-group" aria-hidden="true">' +
            '<div class="mk-samples-skeleton-title"></div>' +
            '<div class="mk-samples-skeleton-meta"></div>' +
            '<div class="mk-samples-skeleton-grid">' + swatches + '</div>' +
          '</section>'
        );
      }).join('');
    }

    function openDrawer(family) {
      currentFamily = family;
      selected.clear();

      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.documentElement.classList.add('prevent-scroll');

      var allLoaded = PRODUCT_FWS.every(function (fw) { return data[fw] || loadFromSessionCache(fw) !== null; });
      if (allLoaded && Object.keys(data).length > 0) {
        renderDrawerContent(family);
        return;
      }

      grid.innerHTML = renderSkeleton();
      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.style.display = 'none';

      loadAllSamples().then(function () { renderDrawerContent(family); });
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('prevent-scroll');
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-open-samples-drawer]');
      if (trigger) {
        e.preventDefault();
        var family = getCurrentFabricFamily(trigger);

        // Luk fabric-drawer først hvis trigger kommer derfra, så drawers ikke overlapper.
        if (trigger.hasAttribute('data-from-detail-view')) {
          var fabricDrawer = document.getElementById('mk-fabric-drawer');
          var closeBtn = fabricDrawer && fabricDrawer.querySelector('[data-close-fabric-drawer]');
          if (closeBtn) closeBtn.click(); else if (fabricDrawer) fabricDrawer.setAttribute('aria-hidden', 'true');
          setTimeout(function () { openDrawer(family); }, 300);
        } else {
          openDrawer(family);
        }
        return;
      }
      if (e.target.closest && e.target.closest('[data-close-samples-drawer]')) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    grid.addEventListener('change', function (e) {
      var input = e.target.closest('.mk-samples-swatch__input');
      if (!input) return;
      var id = parseInt(input.value, 10);
      if (input.checked) {
        if (selected.size >= MAX) {
          input.checked = false;
          return;
        }
        selected.add(id);
        var label = input.closest('.mk-samples-swatch');
        if (label) label.classList.add('is-selected');
      } else {
        selected.delete(id);
        var lbl = input.closest('.mk-samples-swatch');
        if (lbl) lbl.classList.remove('is-selected');
      }
      updateCta();
    });

    if (cta) {
      cta.addEventListener('click', function () {
        if (selected.size === 0 || cta.disabled) return;
        var ids = Array.from(selected);
        cta.disabled = true;
        var origLabel = ctaLabel ? ctaLabel.textContent : '';
        if (ctaLabel) ctaLabel.textContent = 'Tilføjer…';

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add failed: ' + r.status);
            return r.json();
          })
          .then(function () {
            return refreshCart();
          })
          .then(function () {
            if (ctaLabel) ctaLabel.textContent = origLabel;
            closeDrawer();
            openCartDrawerAfterAdd();
          })
          .catch(function (err) {
            console.warn('[mk-samples] add failed', err);
            if (ctaLabel) ctaLabel.textContent = origLabel;
            cta.disabled = false;
          });
      });
    }

    function refreshCart() {
      var theme = window.MinimogTheme && window.MinimogTheme.Cart;
      return Promise.resolve()
        .then(function () { if (theme && typeof theme.refreshCart === 'function') return theme.refreshCart(); })
        .then(function () { if (theme && typeof theme.renderNewCart === 'function') return theme.renderNewCart(); })
        .then(function () {
          var cart = (theme && theme.cart) || null;
          if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function' && cart) {
            window.Shopify.onCartUpdate(cart, false);
          }
          if (theme && typeof theme.updateCartCount === 'function' && cart) {
            theme.updateCartCount(cart);
          }
        })
        .catch(function (e) { console.warn('[mk-samples] refreshCart failed', e); });
    }

    function openCartDrawerAfterAdd() {
      var theme = window.MinimogTheme && window.MinimogTheme.Cart;
      if (theme && typeof theme.openCartDrawer === 'function') {
        try { theme.openCartDrawer(); } catch (e) {}
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
